<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="robot icon"></i>
      {{ $t("automation") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img
          src="/images/icons/automation.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="ui two item top attached tabular menu" ref="tabs">
            <div class="item" data-tab="general">
              <i class="tools icon"></i> {{ $t("general") }}
            </div>
            <div class="item" data-tab="arguments">
              <i class="code icon"></i> {{ $t("arguments") }}
            </div>
          </div>
          <div class="ui bottom attached tab segment" data-tab="general">
            <div class="fields">
              <div class="ten wide field">
                <label for="">{{ $t("name") }}</label>
                <input type="text" name="name" v-model="name" />
              </div>
              <!-- <div class="six wide field">
                <label for="">{{ $t("programmed date") }}</label>
                <div class="ui calendar" ref="programmed_date_calendar">
                  <div class="ui input left icon">
                    <i class="calendar icon"></i>
                    <input type="text" name="programmed_date" />
                  </div>
                </div>
              </div> -->
            </div>
            <div class="fields">
              <div class="five wide field">
                <label for="">{{ $t("group") }}</label>
                <div class="ui selection dropdown" ref="group_dropdown">
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("select one") }}</div>
                  <div class="ui menu"></div>
                </div>
              </div>
              <div class="five wide field">
                <label for="">{{ $t("engine") }}</label>
                <div class="ui selection dropdown" ref="engine_dropdown">
                  <input type="hidden" name="engine" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("select one") }}</div>
                  <div class="ui menu"></div>
                </div>
              </div>
              <div class="six wide field">
                <label for="">{{ $t("automator") }}</label>
                <div class="ui selection dropdown" ref="automation_dropdown">
                  <input type="hidden" name="automator" />
                  <i class="dropdown icon"></i>
                  <div class="default text">{{ $t("select one") }}</div>
                  <div class="ui menu"></div>
                </div>
              </div>
            </div>
            <div class="field">
              <label for="">{{ $t("description") }}</label>
              <textarea
                name="description"
                rows="2"
                v-model="description"
              ></textarea>
            </div>
          </div>
          <div class="ui bottom attached tab segment" data-tab="arguments">
            <div class="field">
              <label for="">{{ $t("arguments") }}</label>
              <code-editor
                v-model="args"
                type="javascript"
                icon="js"
                theme="monokai"
                ref="js_code_editor"
                :title="$t('code')"
                :show_format="true"
              ></code-editor>
              <!-- <textarea
                name="arguments"
                rows="2"
                v-model="description"
              ></textarea> -->
            </div>
          </div>

          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "AutomationModalIndex",
  components: { CodeEditor },
  props: { module_configuration: Object },
  computed: {},
  data() {
    return {
      uuid: "",
      name: "",
      // programmed_date: "",
      group_id: "",
      engine: "",
      automator: "",
      description: "",
      args: "",
      form: undefined,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        if (data.uuid) {
          local_api(vm, "post", "/automation/automation/do-get", {
            u: data.uuid,
          })
            .then((rautom) => {
              console.log("rautom", rautom);
              vm.uuid = rautom.uuid;
              vm.name = rautom.name;

              vm.group_id = rautom.group_id;
              vm.automator = rautom.automator;
              vm.engine = rautom.engine;

              setTimeout(() => {
                if (rautom.group_id)
                  window
                    .jQuery(vm.$refs.group_dropdown)
                    .dropdown("set selected", rautom.group_id);
                if (rautom.engine)
                  window
                    .jQuery(vm.$refs.engine_dropdown)
                    .dropdown("set selected", rautom.engine);
                if (rautom.automator)
                  window
                    .jQuery(vm.$refs.automation_dropdown)
                    .dropdown("set selected", rautom.automator);
              }, 1000);

              vm.description = rautom.description;
              vm.args = rautom.arguments;

              if (data.price) vm.price = data.price;
              // if (data.customer_id) vm.customer_id = data.customer_id;
              // if (data.description) vm.description = data.description;
              // if (data.ctm_customer) {
              //   let ii = window.jQuery(vm.$refs.customer_search).find("input");
              //   if (ii) ii.val(data.ctm_customer.name);
              //   // console.log(ii);
              // }
            })
            .catch((err) => {
              error_toast(err);
            });
        }

        console.log(data);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            // Initialize calendar
            // window.jQuery(vm.$refs.programmed_date_calendar).calendar({
            //   type: "datetime",
            //   today: true,
            //   onChange(value) {
            //     vm.programmed_date = value;
            //   },
            // });

            // console.log(window.jQuery(vm.$refs.tabs).find(".item"));
            window.jQuery(vm.$refs.tabs).find(".item").tab();
          },
          onHide() {
            vm.form.form("reset");
            vm.uuid = "";
            vm.name = "";
            // vm.programmed_date = "";
            vm.group_id = "";
            vm.engine = "";
            vm.automator = "";
            vm.args = "";
            vm.description = "";

            window.jQuery(vm.$refs.group_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.engine_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.automation_dropdown).dropdown("clear");
          },
        })
        .modal("show");

      vm.get_config();

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          // programmed_date: ["empty"],
          engine: ["empty"],
          automator: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/automation/automation/do-save", {
          u: vm.uuid,
          n: vm.name,
          // p: vm.programmed_date,
          g: vm.group_id,
          e: vm.engine,
          a: vm.automator,
          r: vm.args,
          d: vm.description,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    get_config() {
      let vm = this;
      local_api(vm, "post", "/automation/configuration/do-get", {})
        .then((configuration) => {
          if (configuration && configuration.groups) {
            // Groups
            let groups_vls = configuration.groups.map((grp) => {
              return { name: grp.name, value: grp.group_id };
            });
            groups_vls.unshift({ name: vm.$t("select one"), value: "" });
            window
              .jQuery(vm.$refs.group_dropdown)
              .dropdown("setup menu", { values: groups_vls })
              .dropdown({
                onChange(value) {
                  vm.group_id = value;
                },
              });

            // Automators
            let automation_vls = configuration.automators.map((grp) => {
              return { name: grp, value: grp };
            });
            window
              .jQuery(vm.$refs.automation_dropdown)
              .dropdown("setup menu", { values: automation_vls })
              .dropdown({
                onChange(value) {
                  vm.automator = value;
                },
              });

            // Engines
            let engine_vls = ["winium", "webdriver.io"].map((grp) => {
              return { name: grp, value: grp };
            });
            window
              .jQuery(vm.$refs.engine_dropdown)
              .dropdown("setup menu", { values: engine_vls })
              .dropdown({
                onChange(value) {
                  vm.engine = value;
                },
              });
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
